import React, { useState, useEffect } from 'react'
import { store } from '../../app/store';
import UserImg from "../../theme/assets/img/avatars/9.png"
import { postAPI, postAPIForm, getURL } from '../../app/api';

export default function Header() {
  const store_data = JSON.parse(store());

  const [API_URL, setAPIURL] = useState("");

  const fetchURL = async () => {
    const URL = await getURL();
    setAPIURL(URL);
  };

  useEffect(() => {
    fetchURL();
  }, []);
  const { org_id, name, role, class_id, id } = JSON.parse(store()) || {};

  useEffect(() => {
    const INACTIVITY_LIMIT = 60 * 60 * 1000; // 1 hour
    const LOGOUT_URL = "/Logout"; // Change to your logout URL

    let inactivityTimer;

    const logout = () => {
      window.location.href = LOGOUT_URL;
    };

    const resetTimer = () => {
      clearTimeout(inactivityTimer);
      inactivityTimer = setTimeout(logout, INACTIVITY_LIMIT);
    };

    const events = [
      "mousemove",
      "mousedown",
      "keydown",
      "click",
      "scroll",
      "touchstart"
    ];

    events.forEach((event) => {
      window.addEventListener(event, resetTimer, { passive: true });
    });

    // Start the inactivity timer
    resetTimer();

    // Cleanup when the component unmounts
    return () => {
      clearTimeout(inactivityTimer);

      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });
    };
  }, []);

  return (
    <>
      <nav className="layout-navbar container-xxl navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme" id="layout-navbar" >
        {/* <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none">
          <a className="nav-item nav-link px-0 me-xl-4" href="javascript:void(0)">
            <i className="ti ti-menu-2 ti-sm"></i>
          </a>
        </div> */}

        <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
          {/* <div className="navbar-nav align-items-center">
            <div className="nav-item navbar-search-wrapper mb-0">
              <a className="nav-item nav-link search-toggler d-flex align-items-center px-0" href="javascript:void(0);">
                <i className="ti ti-search ti-md me-2"></i>
                <span className="d-none d-md-inline-block text-muted">Search (Ctrl+/)</span>
              </a>
            </div>
          </div> */}

          <ul className="navbar-nav flex-row align-items-center ms-auto">
            {/* <li className="nav-item me-2 me-xl-0">
              <a className="nav-link style-switcher-toggle hide-arrow" href="javascript:void(0);">
                <i className="ti ti-md"></i>
              </a>
            </li>
            <li className="nav-item dropdown-shortcuts navbar-dropdown dropdown me-2 me-xl-0">
              <a
                className="nav-link dropdown-toggle hide-arrow"
                href="javascript:void(0);"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <i className="ti ti-layout-grid-add ti-md"></i>
              </a>
              <div className="dropdown-menu dropdown-menu-end py-0">
                <div className="dropdown-menu-header border-bottom">
                  <div className="dropdown-header d-flex align-items-center py-3">
                    <h5 className="text-body mb-0 me-auto">Shortcuts</h5>
                    <a
                      href="javascript:void(0)"
                      className="dropdown-shortcuts-add text-body"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Add shortcuts"
                    >
                      <i className="ti ti-sm ti-apps"></i>
                    </a>
                  </div>
                </div>
                <div className="dropdown-shortcuts-list scrollable-container">
                </div>
              </div>
            </li>
            <li className="nav-item dropdown-notifications navbar-dropdown dropdown me-3 me-xl-1">
              <a
                className="nav-link dropdown-toggle hide-arrow"
                href="javascript:void(0);"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <i className="ti ti-bell ti-md"></i>
                <span className="badge bg-danger rounded-pill badge-notifications">5</span>
              </a>
              <ul className="dropdown-menu dropdown-menu-end py-0">
                <li className="dropdown-menu-header border-bottom">
                  <div className="dropdown-header d-flex align-items-center py-3">
                    <h5 className="text-body mb-0 me-auto">Notification</h5>
                    <a
                      href="javascript:void(0)"
                      className="dropdown-notifications-all text-body"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Mark all as read"
                    ><i className="ti ti-mail-opened fs-4"></i></a>
                  </div>
                </li>
                <li className="dropdown-notifications-list scrollable-container" style={{ overflowY: 'auto' }}>
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item list-group-item-action dropdown-notifications-item">
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <div className="avatar">
                            <img src="../../theme/assets/img/avatars/1.png" alt="" className="h-auto rounded-circle" />
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="mb-1">Congratulation Lettie 🎉</h6>
                          <p className="mb-0">Won the monthly best seller gold badge</p>
                          <small className="text-muted">1h ago</small>
                        </div>
                        <div className="flex-shrink-0 dropdown-notifications-actions">
                          <a href="javascript:void(0)" className="dropdown-notifications-read"
                          ><span className="badge badge-dot"></span></a>
                          <a href="javascript:void(0)" className="dropdown-notifications-archive"
                          ><span className="ti ti-x"></span></a>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item list-group-item-action dropdown-notifications-item">
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <div className="avatar">
                            <span className="avatar-initial rounded-circle bg-label-danger">CF</span>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="mb-1">Charles Franklin</h6>
                          <p className="mb-0">Accepted your connection</p>
                          <small className="text-muted">12hr ago</small>
                        </div>
                        <div className="flex-shrink-0 dropdown-notifications-actions">
                          <a href="javascript:void(0)" className="dropdown-notifications-read"
                          ><span className="badge badge-dot"></span></a>
                          <a href="javascript:void(0)" className="dropdown-notifications-archive"
                          ><span className="ti ti-x"></span></a>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item list-group-item-action dropdown-notifications-item marked-as-read">
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <div className="avatar">
                            <img src="../../theme/assets/img/avatars/2.png" alt="" className="h-auto rounded-circle" />
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="mb-1">New Message ✉️</h6>
                          <p className="mb-0">You have new message from Natalie</p>
                          <small className="text-muted">1h ago</small>
                        </div>
                        <div className="flex-shrink-0 dropdown-notifications-actions">
                          <a href="javascript:void(0)" className="dropdown-notifications-read"
                          ><span className="badge badge-dot"></span></a>
                          <a href="javascript:void(0)" className="dropdown-notifications-archive"
                          ><span className="ti ti-x"></span></a>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item list-group-item-action dropdown-notifications-item">
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <div className="avatar">
                            <span className="avatar-initial rounded-circle bg-label-success"
                            ><i className="ti ti-shopping-cart"></i></span>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="mb-1">Whoo! You have new order 🛒</h6>
                          <p className="mb-0">ACME Inc. made new order $1,154</p>
                          <small className="text-muted">1 day ago</small>
                        </div>
                        <div className="flex-shrink-0 dropdown-notifications-actions">
                          <a href="javascript:void(0)" className="dropdown-notifications-read"
                          ><span className="badge badge-dot"></span></a>
                          <a href="javascript:void(0)" className="dropdown-notifications-archive"
                          ><span className="ti ti-x"></span></a>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item list-group-item-action dropdown-notifications-item marked-as-read">
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <div className="avatar">
                            <img src={store_data?.image ? `${API_URL}/${store_data?.image}` : UserImg} alt="user-avatar" class="h-auto rounded-circle" id="uploadedAvatar" />
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="mb-1">Application has been approved 🚀</h6>
                          <p className="mb-0">Your ABC project application has been approved.</p>
                          <small className="text-muted">2 days ago</small>
                        </div>
                        <div className="flex-shrink-0 dropdown-notifications-actions">
                          <a href="javascript:void(0)" className="dropdown-notifications-read"
                          ><span className="badge badge-dot"></span></a>
                          <a href="javascript:void(0)" className="dropdown-notifications-archive"
                          ><span className="ti ti-x"></span></a>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item list-group-item-action dropdown-notifications-item marked-as-read">
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <div className="avatar">
                            <span className="avatar-initial rounded-circle bg-label-success"
                            ><i className="ti ti-chart-pie"></i></span>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="mb-1">Monthly report is generated</h6>
                          <p className="mb-0">July monthly financial report is generated</p>
                          <small className="text-muted">3 days ago</small>
                        </div>
                        <div className="flex-shrink-0 dropdown-notifications-actions">
                          <a href="javascript:void(0)" className="dropdown-notifications-read"
                          ><span className="badge badge-dot"></span></a>
                          <a href="javascript:void(0)" className="dropdown-notifications-archive"
                          ><span className="ti ti-x"></span></a>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item list-group-item-action dropdown-notifications-item marked-as-read">
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <div className="avatar">
                            <img src="../../theme/assets/img/avatars/5.png" alt="" className="h-auto rounded-circle" />
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="mb-1">Send connection request</h6>
                          <p className="mb-0">Peter sent you connection request</p>
                          <small className="text-muted">4 days ago</small>
                        </div>
                        <div className="flex-shrink-0 dropdown-notifications-actions">
                          <a href="javascript:void(0)" className="dropdown-notifications-read"
                          ><span className="badge badge-dot"></span></a>
                          <a href="javascript:void(0)" className="dropdown-notifications-archive"
                          ><span className="ti ti-x"></span></a>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item list-group-item-action dropdown-notifications-item">
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <div className="avatar">
                            <img src="../../theme/assets/img/avatars/6.png" alt="" className="h-auto rounded-circle" />
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="mb-1">New message from Jane</h6>
                          <p className="mb-0">Your have new message from Jane</p>
                          <small className="text-muted">5 days ago</small>
                        </div>
                        <div className="flex-shrink-0 dropdown-notifications-actions">
                          <a href="javascript:void(0)" className="dropdown-notifications-read"
                          ><span className="badge badge-dot"></span></a>
                          <a href="javascript:void(0)" className="dropdown-notifications-archive"
                          ><span className="ti ti-x"></span></a>
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item list-group-item-action dropdown-notifications-item marked-as-read">
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <div className="avatar">
                            <span className="avatar-initial rounded-circle bg-label-warning"
                            ><i className="ti ti-alert-triangle"></i></span>
                          </div>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="mb-1">CPU is running high</h6>
                          <p className="mb-0">CPU Utilization Percent is currently at 88.63%,</p>
                          <small className="text-muted">5 days ago</small>
                        </div>
                        <div className="flex-shrink-0 dropdown-notifications-actions">
                          <a href="javascript:void(0)" className="dropdown-notifications-read"
                          ><span className="badge badge-dot"></span
                          ></a>
                          <a href="javascript:void(0)" className="dropdown-notifications-archive"
                          ><span className="ti ti-x"></span
                          ></a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
                <li className="dropdown-menu-footer border-top">
                  <a
                    href="/Admin/Notifications"
                    className="dropdown-item d-flex justify-content-center text-primary p-2 h-px-40 mb-1 align-items-center"
                  >
                    View all notifications
                  </a>
                </li>
              </ul>
            </li> */}
            <li className="nav-item navbar-dropdown dropdown-user dropdown">
              <a className="nav-link dropdown-toggle hide-arrow" href="javascript:void(0);" data-bs-toggle="dropdown">
                <div className='d-flex gap-3 align-items-center'>
                  <div className="avatar avatar-online">
                    <img src={store_data?.image ? `${API_URL}/${store_data?.image}` : UserImg} alt="user-avatar" class="h-auto rounded-circle customAvatarImg" id="uploadedAvatar" />
                  </div>
                  <div>
                    <span className="fw-semibold d-block">{store_data?.name}</span>
                    <small className="text-muted">{store_data?.role}</small>
                  </div>
                </div>
              </a>
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <a className="dropdown-item" href="/Admin/Profile">
                    <div className="d-flex">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar avatar-online">
                          <img src={store_data?.image ? `${API_URL}/${store_data?.image}` : UserImg} alt="" className="rounded-circle" style={{ height: "40px" }} />
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <span className="fw-semibold d-block">{store_data?.name}</span>
                        <small className="text-muted">{store_data?.role}</small>
                      </div>
                    </div>
                  </a>
                </li>
                <li>
                  <div className="dropdown-divider"></div>
                </li>
                <li>
                  <a className="dropdown-item" href="/Admin/Profile">
                    <i className="ti ti-user-check me-2 ti-sm"></i>
                    <span className="align-middle">My Profile</span>
                  </a>
                </li>
                {/* <li>
                  <a className="dropdown-item" href="/Admin/General">
                    <i className="ti ti-settings me-2 ti-sm"></i>
                    <span className="align-middle">Settings</span>
                  </a>
                </li> */}
                {/* <li>
                  <a className="dropdown-item" href="/Admin/Billing">
                    <span className="d-flex align-items-center align-middle">
                      <i className="flex-shrink-0 ti ti-credit-card me-2 ti-sm"></i>
                      <span className="flex-grow-1 align-middle">Membership</span>
                    </span>
                  </a>
                </li> */}
                <li>
                  <a className="dropdown-item" href="/Admin/Security">
                    <i className="ti ti-lock me-2 ti-sm"></i>
                    <span className="align-middle">Change Password</span>
                  </a>
                </li>
                <li>
                  <div className="dropdown-divider"></div>
                </li>
                <li>
                  <a className="dropdown-item" href="/Logout">
                    <i className="ti ti-logout me-2 ti-sm"></i>
                    <span className="align-middle">Log Out</span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="navbar-search-wrapper search-input-wrapper d-none">
          <input
            type="text"
            className="form-control search-input container-xxl border-0"
            placeholder="Search..."
            aria-label="Search..."
          />
          <i className="ti ti-x ti-sm search-toggler cursor-pointer"></i>
        </div>
      </nav>
    </>
  )
}
